import * as React from "react";

export interface Props {
  isBankView: boolean;
}

const Breadcrumbs = ({ isBankView }: Props) => {
  let sub = "Balance Sheet Summaries from Failed Banks"; 
  let approotlink;
  if( isBankView ){
    sub = "Balance Sheet Summary"
    approotlink = <a className="text-prussian-blue text-capitalize" aria-label="Assets" href="../">
      Balance Sheet Summaries from Failed Banks
    </a>
  }
  return (
    <main id="main-content" className="grid-container overflow-hidden bg-white">

    <div className="padding-top-1px tablet:padding-y-0 grid-row margin-x-neg-1 tablet:margin-x-0"> 
    <div className="grid-col-12 order-1 tablet:order-2 tablet:margin-x-2 margin-bottom-2 tablet:margin-y-2 font-alt-2xs text-ls-2 text-gray text-italic">
    <nav aria-label="breadcrumb" id="usa-breadcrumbs">
      <div className="usa-breadcrumb">
      <ol className="padding-left-0 margin-top-0">
        <li className="display-inline">
          <a className="text-prussian-blue" href="https://www.fdic.gov/index.html" aria-label="FDIC.gov home page">Home</a>
        </li>
      <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/bank/index.html " >Industry Analysis</a>  </li>
          <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Assets" href=" https://www.fdic.gov/resources/resolutions/bank-failures/failed-bank-list/index.html ">Failed Banks</a> </li>
          {isBankView === true ? ( <li className="display-inline"><a className="text-prussian-blue text-capitalize" aria-label="Assets" href="/drripbal/">{approotlink} </a> </li>
) : ''}
      <li className="display-none tablet:display-inline">{sub}</li></ol>
   
           </div>
      </nav>
    </div>
    </div>
    </main>

  );
};

export default Breadcrumbs;
